import { render, staticRenderFns } from "./ChangeCompleted.vue?vue&type=template&id=b9a55096&scoped=true&"
import script from "./ChangeCompleted.vue?vue&type=script&lang=js&"
export * from "./ChangeCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a55096",
  null
  
)

export default component.exports